// extracted by mini-css-extract-plugin
export default {"section":"EafJk","heading":"KaVxO","heading-title":"cAceu","actions":"K8TkL"};